<template>
  <dialog-layout
    :open="open"
    :maxWidth="maxWidth"
    :title="title"
    eager
    :loading="loading"
    :enableCancel="enableCancel"
    :confirmBtnTitle="confirmBtnTitle"
    :cancelBtnTitle="cancelBtnTitle"
    @close="_dialogAction($event)"
  >
    <template slot="content">
      <v-form class="mt-4" :ref="formRef" @submit.prevent>
        <slot></slot>
      </v-form>
    </template>
  </dialog-layout>
</template>

<script>
import DialogLayout from '@/components/layout/DialogLayout.vue'
export default {
  name: 'FormDialog',
  components: {
    DialogLayout,
  },
  props: {
    formRef: {
      type: String,
      required: true,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: Number,
      default: 500,
    },
    enableCancel: {
      type: Boolean,
      default: true
    },
    confirmBtnTitle: {
      type: String,
      required: false,
      default: 'confirm',
    },
    cancelBtnTitle: {
      type: String,
      required: false,
      default: 'cancel',
    },
  },
  computed: {
    loading() {
      return this.formLoading || this.$store.getters.isLoading;
    }
  },
  data: () => ({
    open: false,
    formLoading: false,
    editId: null,
  }),
  methods: {
    show() {
      this.open = true
    },
    hide() {
      this.open = false
      this.formLoading = false
      this.setEditId(null)
    },
    setLoading(loading) {
      this.formLoading = loading
    },
    setEditId(id) {
      this.editId = id
    },
    getEditId() {
      return this.editId
    },
    async reset() {
      await this.$refs[this.formRef].reset();
    },

    _dialogAction(action) {
      if (this.loading) {
        this.$store.dispatch('toggleSnack', {
          message: 'processing',
        })
        return
      }

      if (action === true) {
        const valid = this.$refs[this.formRef].validate()
        if (!valid) {
          this.$store.dispatch('toggleSnack', {
            message: 'required',
          })
          return
        }

        this.formLoading = true
        this.$emit('submit-clicked', true)
      } else {
        this.hide()
      }
    },
  },
}
</script>
